export default class Token {
  static get(name) {
    const data = JSON.parse(localStorage.getItem("givemagic-dashboard")) || {};
    return data[name];
  }

  static set(name, value) {
    let data = JSON.parse(localStorage.getItem("givemagic-dashboard")) || {};
    data[name] = value;
    data = JSON.stringify(data);
    localStorage.setItem("givemagic-dashboard", data);
    return data;
  }

  static remove(name) {
    const data = JSON.parse(localStorage.getItem("givemagic-dashboard")) || {};
    delete data[name];
    localStorage.setItem("givemagic-dashboard", JSON.stringify(data));
    return true;
  }

  static removeAll() {
    localStorage.removeItem("givemagic-dashboard");
    return true;
  }
}
